import React from "react";
import { Modal, Button } from "react-bootstrap";

const LeaseHistoryDetailModal = ({ show, onHide, leasehistory }) => {
  if (!leasehistory) return null;

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return dateString
      ? new Date(dateString).toLocaleDateString(undefined, options)
      : "N/A";
  };

  const leasingAmount = leasehistory.id_lease?.leasing_amount || 0;
  const vehicleCount = leasehistory.id_vehicle?.length || 0;
  const totalLeasing = leasingAmount * vehicleCount;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Lease History Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Vehicles :</strong>
          <ul>
            {leasehistory.id_vehicle?.map((v) => (
              <li key={v._id}>
                {v.numberplate}{" "}
                {v.id_type?.vehicle_type ? `(${v.id_type.vehicle_type})` : ""}
              </li>
            ))}
          </ul>
        </p>
        <p>
          <strong>Leasing Partner :</strong>{" "}
          {leasehistory.id_lease?.leasing_partner || "N/A"}
        </p>
        <p>
          <strong>Lease Status :</strong>{" "}
          {leasehistory.id_lease?.status || "N/A"}
        </p>
        <p>
          <strong>Onboarding Date :</strong>{" "}
          {formatDate(leasehistory.id_lease?.onboardingDate)}
        </p>
        <p>
          <strong>Per Vehicle Leasing Amount :</strong> ₹{leasingAmount}
        </p>
        <p>
          <strong>Total Leasing :</strong> ₹{totalLeasing}
        </p>
        <p>
          <strong>Total Vehicles :</strong> {vehicleCount}
        </p>

        <p>
          <strong>Month/Year :</strong> {leasehistory.month}/{leasehistory.year}
        </p>
        <p>
          <strong>Payment Paid :</strong>{" "}
          {leasehistory.paymentPaid ? "Yes" : "No"}
        </p>
        <p>
          <strong>Actual Amount :</strong> {leasehistory.actualAmount}
        </p>
        <p>
          <strong>Remaining Amount :</strong> {leasehistory.remainingAmount}
        </p>
        <p>
          <strong>Payment Paid Date :</strong>{" "}
          {formatDate(leasehistory.paymentPaidDate)}
        </p>

        <p>
          <strong>Created At :</strong> {formatDate(leasehistory.createdAt)}
        </p>
        <p>
          <strong>Updated At :</strong> {formatDate(leasehistory.updatedAt)}
        </p>
        <p>
          <strong>Comments :</strong> {leasehistory.comments}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LeaseHistoryDetailModal;
